import { ArrowBack } from '@mui/icons-material'
import { Card, CardContent, CardHeader, FormControl, Grid, IconButton, MenuItem, Select, Table, TableBody, TableCell, TableRow } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func'
import { getDataWithResponse } from 'global/getFunc'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import userStore from 'store/userStore'
import DetailKomponen from './DetailKomponen'
import CapaianBulanan from './CapaianBulanan'
import { postDataWithResponse } from 'global/postFunc'
import MapSingle from 'examples/Maps/MapSingle'
import Monev from 'pages/superAdmin/Monev'

const Komponen = () => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const navigate = useNavigate()
    const location = useLocation()
    const id = location.state;
    const [data, setData] = useState({});

    const [program, setProgram] = useState({})
    const [kegiatan, setKegiatan] = useState({})
    const [subKegiatan, setSubKegiatan] = useState({})
    const [opd, setOpd] = useState({})
    const [basemap, setBasemap] = useState('streets-navigation-vector')

    useEffect(() => {
        reqKomponen();
        console.log(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps, no-use-before-define
    }, [])

    const reqKomponen = () => {
        addReq()
        getDataWithResponse(
            `/admin-opd/komponen-belanja/show/${id}`,
            decryptedUser,
            (res) => {
                setData(res)
                console.log(res);
            },
            (res) => {
                console.log(res)
            }
        )
    }

    useEffect(() => {
        data.kd_subkegiatan !== undefined && reqTrSubKegiatan()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const reqTrSubKegiatan = () => {
        addReq()
        getDataWithResponse(
            `/admin-opd/get-tr-perencanaan-by-id/${data.ta}-${data.kd_pd}-${data.kd_subkegiatan}`,
            decryptedUser,
            (res) => {
                setSubKegiatan(res)
            },
            (res) => {
                console.log(res)
            }
        )
    }

    useEffect(() => {
        if (subKegiatan.kegiatan !== undefined) {
            addReq()
            getDataWithResponse(
                `/admin-opd/get-tr-perencanaan-by-id/${data.ta}-${data.kd_pd}-${subKegiatan.kegiatan}`,
                decryptedUser,
                (res) => {
                    setKegiatan(res)
                },
                (res) => {
                    console.log(res)
                }
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subKegiatan])

    useEffect(() => {
        if (kegiatan.program !== undefined) {
            addReq()
            getDataWithResponse(
                `/admin-opd/get-tr-perencanaan-by-id/${data.ta}-${data.kd_pd}-${kegiatan.program}`,
                decryptedUser,
                (res) => {
                    setProgram(res)
                },
                (res) => {
                    console.log(res)
                }
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [kegiatan])

    const reqOpd = () => {
        postDataWithResponse(
            `/sa/opd/get-opd-by-id`,
            {
                id: data.kd_pd
            },
            decryptedUser,
            (res) => {
                setOpd(res)
            },
            (res) => {
                console.log(res)
            }
        )
    }

    useEffect(() => {
        data.kd_pd !== undefined && reqOpd()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])



    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Kembali</ArgonTypography>
                        }
                        avatar={
                            <IconButton variant="outlined" onClick={() => navigate(-1)}><ArrowBack fontSize='small' /></IconButton>
                        }
                    />
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableBody>
                                <TableRow key={0} >
                                    <TableCell sx={{ fontSize: 'small' }}>Tahun Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.ta}</TableCell>
                                </TableRow>
                                <TableRow key={1} >
                                    <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {opd.kd_pd} {opd.nama_pd}</TableCell>
                                </TableRow>
                                <TableRow key={2} >
                                    <TableCell sx={{ fontSize: 'small' }}>Program</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {program.kode} {program.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={3} >
                                    <TableCell sx={{ fontSize: 'small' }}>Kegiatan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {kegiatan.kode} {kegiatan.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={4} >
                                    <TableCell sx={{ fontSize: 'small' }}>Sub Kegiatan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {subKegiatan.kode} {subKegiatan.uraian}</TableCell>
                                </TableRow>
                                <TableRow key={5} >
                                    <TableCell sx={{ fontSize: 'small' }}>Sumber Pendanaan</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.kode_sumber_dana} {data.uraian_sumber_dana}</TableCell>
                                </TableRow>
                                <TableRow key={6} >
                                    <TableCell sx={{ fontSize: 'small' }}>Rekening Akun</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.kode_rekening_akun} {data.uraian_rekening_akun}</TableCell>
                                </TableRow>
                                <TableRow key={7} >
                                    <TableCell sx={{ fontSize: 'small' }}>Komponen</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.nama_komponen}</TableCell>
                                </TableRow>
                                <TableRow key={8} >
                                    <TableCell sx={{ fontSize: 'small' }}>Volume</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {data.volume} {data.satuan}</TableCell>
                                </TableRow>
                                <TableRow key={9} >
                                    <TableCell sx={{ fontSize: 'small' }}>Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>
                                        : {
                                            parseInt(data.anggaran).toLocaleString?.('id-ID', {
                                                style: 'currency',
                                                currency: 'IDR',
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                            })
                                        }
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </ArgonBox>
            <ArgonBox mb={3}>
                <DetailKomponen
                    dataKomponen={data}
                />
            </ArgonBox>
            <ArgonBox mb={3}>
                <CapaianBulanan
                    dataKomponen={data}
                />
            </ArgonBox>

            {
                data.penerima_manfaat === 'Off Site' &&
                <>
                    <Monev
                        komponenData={data}
                        allowEdit={true}
                    />


                    {
                        data.geometry_type !== '' &&
                        <ArgonBox>
                            <Card sx={{ height: '500px' }}>
                                {/* <CardContent sx={{ height: '90vh' }}> */}
                                <MapSingle
                                    data={data}
                                    basemap={basemap}
                                />
                                {/* </CardContent> */}
                            </Card>
                        </ArgonBox>
                    }
                </>

            }

        </ArgonBox>
    )
}

export default Komponen